import { useDispatch, useSelector } from "react-redux";
import { setIsAllocatedViewLegendOpen } from "../store/allocatedSlice";
import EmptyDockDoor from "../components/AllocatedView/EmptyDockDoor";
import DockDoor from "../components/AllocatedView/DockDoor";
import LegendPopup from "../components/AllocatedView/LegendPopup";
import expandIcon from "../assets/icons/expandDedault.png";
import "../assets/css/AllocatedView/AllocatedView.css";

const STYLE_CONFIG_BY_STATUS = {
  A: {
    backgroundColor: "#EEC909",
    textColor: "#000000"
  },
  C: {
    backgroundColor: "#238749",
    textColor: "#FFFFFF"
  },
  S: {
    backgroundColor: "#BF2E3A",
    textColor: "#FFFFFF"
  },
  E: {
    backgroundColor: "#38AB00",
    textColor: "#FFFFFF"
  },
  P: {
    backgroundColor: "#E77400",
    textColor: "#FFFFFF"
  },
  H: {
    backgroundColor: "#01CC1F",
    textColor: "#000000"
  }
};

const AllocatedView = () => {
  const dispatch = useDispatch();
  const {
    isAllocatedViewLegendOpen,
    allocatedViewData,
    isAllocatedViewLoading
  } = useSelector((state) => state.allocated);

  const sliceDockDoorName = (dockDoor) =>
    dockDoor.substring(dockDoor.length - 2);

  const getStylesByStatus = (status) => STYLE_CONFIG_BY_STATUS[status];

  const renderDockDoor = () => {
    return allocatedViewData.map((item, index) => {
      const { dockDoor, trailerNumber, status } = item;

      const { backgroundColor, textColor } = { ...getStylesByStatus(status) };

      if (trailerNumber == null)
        return (
          <EmptyDockDoor key={index} dockDoor={sliceDockDoorName(dockDoor)} />
        );
      return (
        <DockDoor
          key={index}
          data={item}
          dockDoor={sliceDockDoorName(dockDoor)}
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
      );
    });
  };

  if (allocatedViewData?.length === 0 || isAllocatedViewLoading) {
    return (
      <div className="loader-container">
        <div className="allocated-rm-loader">
          {isAllocatedViewLoading ? (
            <>
              <h4>Loading Allocated View Data...</h4>
              <div className="spinner" />
            </>
          ) : (
            <h4>No data available!</h4>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="allocated-container">
      <div
        id="allocated-popup-wrapper-id"
        className="allocatedview-legend-popup-wrapper"
      >
        <div className="allocated-popup-container">
          <div className="dock-door-list">{renderDockDoor()}</div>

          {isAllocatedViewLegendOpen ? <LegendPopup /> : null}
        </div>
      </div>
      {!isAllocatedViewLegendOpen && allocatedViewData?.length > 0 ? (
        <div
          className="legend-modal"
          onClick={() => dispatch(setIsAllocatedViewLegendOpen(true))}
        >
          <div>
            <img alt="bottom_arrow_icon" src={expandIcon} />
          </div>
          <div>
            <span className="legend-modal-btn">Show Legends</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AllocatedView;
